import { areCybusCoreContainersEquals, areCybusDetailedCoreContainersEquals, Capability, type CybusCoreContainer } from '../../../../../../domain'

import type { PageSubscriptionsTypes, SingleSubscriptionsTypes } from '../../../../../../application'

import type { BackendJsonResponseContent } from '../../../../../Connectware'
import { type CommonContainer, ContainerStrategy } from './Base'
import { mapDetailedCoreContainer } from './Mappers'

type IdAux = Pick<CybusCoreContainer, 'name'>

export class CoreContainerStrategy extends ContainerStrategy<'coreContainers', never, IdAux> {
    protected override readonly areEquals = areCybusCoreContainersEquals

    protected readonly containerMetadataConfig: ContainerStrategy<'coreContainers', never, IdAux>['containerMetadataConfig'] = {
        capability: Capability.CORE_CONTAINERS_READ,
        method: 'GET',
        path: '/api/core-containers/+/inspect',
    }

    protected readonly containersOrchestratorConfig: ContainerStrategy<'coreContainers', never, IdAux>['containersOrchestratorConfig'] = {
        capability: Capability.CORE_CONTAINERS_READ,
        method: 'GET',
        path: '/api/core-containers/orchestrator',
    }

    protected readonly containersConfig: ContainerStrategy<'coreContainers', never, IdAux>['containersConfig'] = {
        capability: Capability.CORE_CONTAINERS_READ,
        method: 'GET',
        path: '/api/core-containers',
    }

    protected readonly singleContainerConfig = null

    protected readonly mapSingleRetrieval = null

    override readonly requiredPermissions = [Capability.CORE_CONTAINERS_READ]

    // eslint-disable-next-line class-methods-use-this
    protected readonly mapIdAux = (id: string): IdAux | null => {
        return { name: id }
    }

    // eslint-disable-next-line class-methods-use-this
    protected readonly mapListContainer = (base: CommonContainer, idMetadata: IdAux): PageSubscriptionsTypes['coreContainers'] => {
        return { ...base, ...idMetadata }
    }
}

export class DetailedCoreContainerStrategy extends ContainerStrategy<never, 'coreContainer', IdAux> {
    protected override readonly areEquals = areCybusDetailedCoreContainersEquals

    protected readonly mapIdAux = null

    protected readonly mapListContainer = null

    protected readonly containerMetadataConfig = null

    protected readonly containersOrchestratorConfig = null

    protected readonly containersConfig = null

    protected readonly singleContainerConfig: ContainerStrategy<never, 'coreContainer', IdAux>['singleContainerConfig'] = {
        capability: Capability.CORE_CONTAINER_READ,
        method: 'GET',
        path: '/api/core-containers/+/inspect',
    }

    override readonly requiredPermissions = [Capability.CORE_CONTAINER_READ]

    // eslint-disable-next-line class-methods-use-this
    protected readonly mapSingleRetrieval = (
        id: string,
        data: BackendJsonResponseContent<'/api/core-containers/+/inspect', 'GET'>
    ): SingleSubscriptionsTypes['coreContainer'] => mapDetailedCoreContainer(id, id, data)
}
